export function updateFilter ({ commit }, payload) {
  commit('updateFilter', payload)
}
